export default "__VITE_ASSET__DCiDc6ky__"